<template>
  <svg viewBox="0 0 20 16" class="fill-current exercise-icon" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_118_212)">
      <path d="M4.5466 12.7276C3.38179 12.7276 2.34678 11.9829 1.97103 10.8728L1.94712 10.7908C1.8583 10.497 1.82073 10.2511 1.82073 10.0017V5.04184L0.054717 10.9308C-0.170731 11.7985 0.345067 12.6968 1.2127 12.9359L12.4578 15.9488C12.5978 15.9863 12.7379 16.0034 12.8779 16.0034C13.6021 16.0034 14.2648 15.5218 14.4493 14.8147L15.1051 12.731H4.5466V12.7276Z"/>
      <path d="M6.54489 5.08968C7.34762 5.08968 8.00005 4.43725 8.00005 3.63452C8.00005 2.83178 7.34762 2.17935 6.54489 2.17935C5.74216 2.17935 5.08972 2.8352 5.08972 3.63793C5.08972 4.44066 5.74216 5.08968 6.54489 5.08968Z"/>
      <path d="M15.6379 0H4.72753C3.72326 0 2.91028 0.816396 2.91028 1.81725V9.81725C2.91028 10.8181 3.72667 11.6345 4.72753 11.6345H15.6379C16.6387 11.6345 17.4551 10.8181 17.4551 9.81725V1.81725C17.4551 0.816396 16.6387 0 15.6379 0ZM4.72753 1.45517H15.6379C15.8394 1.45517 15.9999 1.61913 15.9999 1.81725V6.98207L13.7011 4.3006C13.4585 4.01366 13.1033 3.86336 12.7241 3.85312C12.3484 3.85653 11.9931 4.02391 11.754 4.31084L9.05204 7.55252L8.17074 6.67464C7.67202 6.17592 6.86246 6.17592 6.36715 6.67464L4.35861 8.67976V1.81383C4.36203 1.61913 4.52599 1.45517 4.72753 1.45517Z"/>
    </g>
    <defs>
      <clipPath id="clip0_118_212">
        <rect width="17.4552" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "SkinIcon",
}
</script>

<style scoped>

</style>